import { api_react_v1_insights_path } from '@routes';

import request from './request';

export interface Insight {
  top_results: [string, number];
  total_count: number;
}

export async function getInsight(
  relationshipSource: string,
  relationshipType: string,
  limit: number
): Promise<Insight> {
  const resp = await request(
    'get',
    api_react_v1_insights_path({
      relationship_source: relationshipSource,
      relationship_type: relationshipType,
      limit: limit,
    })
  );
  return resp;
}
